module.exports = __webpack_public_path__ + "img/HA1512-163.62a8a1c9.jpg";